import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { networkHub, networkMesh, networkNodes } from '../data/networkNodes';
const TRAVEL = 1.6;
const REST = 2.4;
export function NodeNetwork({
  hubLabel = '/v1/tasks'
}: {
  hubLabel?: string;
}) {
  const reduce = useReducedMotion();
  const byId = Object.fromEntries(networkNodes.map(n => [n.id, n]));
  const hub = networkHub;
  return <div className="overflow-hidden rounded-3xl border border-line bg-surface" data-id="element-238" data-mp="1qpukakrt05xg">
      <div className="flex items-center justify-between border-b border-line px-4 py-2.5 font-mono text-xs" data-id="element-239" data-mp="1mpan5h78d2bb">
        <span className="text-muted" data-id="element-240" data-mp="20gyz9khhbqsa">dispatch.live</span>
        <span className="flex items-center gap-1.5 text-accent" data-id="element-241" data-mp="20iifjb34y1u2">
          <span className="h-1.5 w-1.5 rounded-full bg-accent" aria-hidden="true" data-id="element-242" data-mp="1voxdn7yf8npl" />
          {networkNodes.length} nodes streaming
        </span>
      </div>
      <svg viewBox="0 0 600 400" className="block w-full" role="img" aria-label="Tasks dispatching from the LocalTask API to taskers in cities around the world" data-id="element-243" data-mp="131bag0t3vl39">
        <defs data-id="element-244" data-mp="3uaun28tnnt9r">
          <pattern id="tl-dots" width="20" height="20" patternUnits="userSpaceOnUse" data-id="element-245" data-mp="3u9a2nc121qpm">
            <circle cx="1" cy="1" r="1" className="fill-line" data-id="element-246" data-mp="32yteslw5jn7" />
          </pattern>
        </defs>
        <rect width="600" height="400" fill="url(#tl-dots)" data-id="element-247" data-mp="7wbh90iqxmew" />

        {networkMesh.map(([a, b]) => <line key={`${a}-${b}`} x1={byId[a].x} y1={byId[a].y} x2={byId[b].x} y2={byId[b].y} className="stroke-line" strokeWidth={1} strokeDasharray="3 5" data-id="element-248" data-mp="cwpgpu6a7o1b" />)}

        {networkNodes.map(n => <line key={`edge-${n.id}`} x1={hub.x} y1={hub.y} x2={n.x} y2={n.y} className="stroke-ink/15" strokeWidth={1} data-id="element-249" data-mp="3lcsnzythfap4" />)}

        {!reduce && networkNodes.map(n => <motion.circle key={`packet-${n.id}`} r={3.5} className="fill-accent" initial={{
        cx: hub.x,
        cy: hub.y,
        opacity: 0
      }} animate={{
        cx: [hub.x, n.x],
        cy: [hub.y, n.y],
        opacity: [0, 1, 1, 0]
      }} transition={{
        duration: TRAVEL,
        delay: n.delay,
        repeat: Infinity,
        repeatDelay: REST,
        ease: [0.45, 0, 0.55, 1]
      }} data-id="element-250" data-mp="10ma4qrhalbhg" />)}

        {networkNodes.map(n => {
        const right = n.x >= hub.x;
        return <g key={n.id} data-id="element-251" data-mp="2hyfpj1n4ndaj">
              {!reduce && <motion.circle cx={n.x} cy={n.y} r={6} className="fill-accent" initial={{
            scale: 1,
            opacity: 0
          }} animate={{
            scale: [1, 2.6],
            opacity: [0.5, 0]
          }} style={{
            transformOrigin: `${n.x}px ${n.y}px`
          }} transition={{
            duration: 0.6,
            delay: n.delay + TRAVEL,
            repeat: Infinity,
            repeatDelay: TRAVEL + REST - 0.6,
            ease: 'easeOut'
          }} data-id="element-252" data-mp="2hyz2s51u1di8" />}
              <circle cx={n.x} cy={n.y} r={5} className="fill-surface stroke-accent" strokeWidth={2} data-id="element-253" data-mp="1u6sfdve34guy" />
              <text x={right ? n.x + 11 : n.x - 11} y={n.y + 4} textAnchor={right ? 'start' : 'end'} className="fill-ink font-mono" fontSize={11} data-id="element-254" data-mp="9opy6zn6cbpo">
                {n.city}
              </text>
            </g>;
      })}

        <g data-id="element-255" data-mp="tf338h4lgr1l">
          {!reduce && <motion.rect x={hub.x - 34} y={hub.y - 15} width={68} height={30} rx={9} className="fill-accent" initial={{
          scale: 1,
          opacity: 0.35
        }} animate={{
          scale: [1, 1.35],
          opacity: [0.35, 0]
        }} style={{
          transformOrigin: `${hub.x}px ${hub.y}px`
        }} transition={{
          duration: 1.2,
          repeat: Infinity,
          ease: 'easeOut'
        }} data-id="element-256" data-mp="tg4rjnamfa19" />}
          <rect x={hub.x - 34} y={hub.y - 15} width={68} height={30} rx={9} className="fill-ink" data-id="element-257" data-mp="3967q1i078zgx" />
          <text x={hub.x} y={hub.y + 4} textAnchor="middle" className="fill-canvas font-mono" fontSize={11} fontWeight={500} data-id="element-258" data-mp="3ofumb4q89i2x">
            {hubLabel}
          </text>
        </g>
      </svg>
    </div>;
}